import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FC } from 'react'
import { Provider } from 'react-redux'

import AccountProvider from 'src/components/data/providers/AccountProvider'
import PrinterProvider from 'src/components/data/providers/PrinterProvider'
import SettingsProvider from 'src/components/data/providers/SettingsProvider'
import WizardProvider from 'src/components/data/providers/WizardProvider'
import Compose from 'src/components/ui/atoms/Compose'
import Toaster from 'src/components/ui/atoms/Toaster'
import { store as reduxStore } from 'src/redux/store'
import App from './App'
import Router from './components/ui/atoms/Router/Router'
import GlobalError from './components/ui/molecules/GlobalError'

const queryClient = new QueryClient()

const ErrorBoundary = Sentry.ErrorBoundary as any

const AppProvider: FC = () => (
  <ErrorBoundary fallback={<GlobalError />}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <Compose
          components={[
            ({ children }) => <Provider store={reduxStore}>{children}</Provider>,
            AccountProvider,
            SettingsProvider,
            PrinterProvider,
            WizardProvider,
          ]}
        >
          <App />
          <Toaster />
        </Compose>
      </Router>
    </QueryClientProvider>
  </ErrorBoundary>
)

export default AppProvider
